module.exports = __webpack_public_path__ + "static/img/banner-small-02.bd79539.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner-small-02.png
// module id = 9bxb
// module chunks = 1